import firebase from "firebase/compat/app";
import { getAuth } from "firebase/auth";

// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyAe84akf6PcRSJywDirSWXfAAaSNNH-7Mw",
    authDomain: "milk-honey-order.firebaseapp.com",
    projectId: "milk-honey-order",
    storageBucket: "milk-honey-order.appspot.com",
    messagingSenderId: "219522929836",
    appId: "1:219522929836:web:d2861506ae6c042f43bb09",
    measurementId: "G-WEJGQJZ4JS"
};

const app = firebase.initializeApp(firebaseConfig);

export const auth = getAuth();

// Initialize Firebase
export default app;